import React from "react";

const Button = ({ link, text, icon, classes, ...rest }) => {
	if (!link) {
		return (
			<button className={` ${classes && classes}`} {...rest}>
				{text} {icon && icon}
			</button>
		);
	}
	return (
		<a className={` ${classes && classes}`} href={link}>
			{text} {icon && icon}
		</a>
	);
};

export default Button;
